import * as Preact from 'preact';
import { Box } from '@mui/material';
import * as Button from './A_Button';
import * as IconButton from './A_IconButton';
import ShareIcon from '@mui/icons-material/Share';
export var Component = function (props) {
    var _a;
    return (Preact.h(Box, { sx: {
            display: 'flex',
            gap: '8px',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
        } },
        props.onShareClick && (Preact.h(IconButton.Component, { size: "medium", color: "secondary", onClick: props.onShareClick },
            Preact.h(ShareIcon, { fontSize: "small" }))),
        props.secondary && (Preact.h(Button.Component, { size: "medium", color: "secondary", variant: "outlined", disabled: props.secondary.disabled, onClick: props.secondary.onActionClick, startIcon: props.secondary.icon, sx: { width: { xs: '100%', md: 'auto' } } }, props.secondary.actionText)),
        props.primary && (Preact.h(Button.Component, { size: "medium", color: "primary", variant: "contained", disabled: props.primary.disabled, onClick: props.primary.onActionClick, loading: (_a = props.primary.actionLoading) !== null && _a !== void 0 ? _a : false, startIcon: props.primary.icon, sx: { width: { xs: '100%', md: 'auto' } } }, props.primary.actionText))));
};
Component.displayName = 'CTACombo';
